import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { accountsApi } from './accountsApi';
import { accountSetupApi } from './accountSetupApi';
import { adminInvestorsApi } from './adminInvestorsApi';
import { advisorGroupsApi } from './advisorGroupsApi';
import { advisorInvestorsApi } from './advisorInvestorsApi';
import { masterSearchApi } from './masterSearchApi';
import { aggregatedAccountsApi } from './aggregatedAccountsApi';
import { advisorAggregatedHoldingsApi } from './advisorAggregatedHoldingsApi';
import { appViewApi } from './appViewApi';
import appViewReducer from './appViewSlice';
import authApi from './authApi';
import authReducer from './authSlice';
import { cacheInvalidationMiddleware } from './cacheInvalidationMiddleware';
import { cashFlowApi } from './cashFlowApi';
import { classificationsApi } from './classificationsApi';
import { clientActivityApi } from './clientActivityApi';
import { clientsApi } from './clientsApi';
import { colorsApi } from './colorsApi';
import { contactsApi } from './contactsApi';
import { dashboardApi } from './dashboardApi';
import { dashboardMessagesApi } from './dashboardMessagesApi';
import { disclaimersApi } from './disclaimersApi';
import { firmApi } from './firmApi';
import { socialSettingsApi } from './socialSettingsApi';
import { diversificationsApi } from './diversificationsApi';
import { documentsApi } from './documentsApi';
import { errorsApi } from './errorsApi';
import { exportApi } from './exportApi';
import { financialInstitutionsApi } from './financialInstitutionsApi';
import { gridColumnsApi } from './gridColumnsApi';
import { holdingsApi } from './holdingsApi';
import { insightsApi } from './insightsApi';
import { notificationsApi } from './notificationsApi';
import { permissionsApi } from './permissionsApi';
import { reportsApi } from './reportsApi';
import { quickLinksResourcesApi } from './quickLinksResourcesApi';
import { settingsApi } from './settingsApi';
import { pageVisibilityApi } from './pageVisibilityApi';
import { tabsApi } from './tabsApi';
import { transactionsApi } from './transactionsApi';
import { teamMemberApi } from './teamMemberApi';
import { usersApi } from './usersApi';
import { aggregatorCredentialsApi } from './aggregatorCredentialsApi';
import { wealthsApi } from './wealthsApi';
import { yodleeApi } from './yodleeApi';
import { mgpApi } from './mgpApi';
import { integrationsApi } from './integrationsApi';
import { performanceReportsApi } from './performanceReportsApi';
import { eConsentApi } from './eConsentApi';
import filterReducer from './filterSlice';
import viewingTagReducer from './viewingTagSlice';
import { termsApi } from './termsApi';
import { advisorGroupModuleLocalizationsApi } from './advisorGroupModuleLocalizationsApi';
import { propertyApi } from './propertyApi';
import { eConsentConfigApi } from './eConsentConfigApi';
import { dataFeedsApi } from './dataFeedsApi';
import { setupAccountsApi } from './setupAccountsApi';
import { homeAwayInstitutionsApi } from './homeAwayInstitutionsApi';
import { feedClassificationsApi } from './feedClassificationsApi';
import { clientInvitationConfigApi } from './clientInvitationConfigApi';
import { clientRelationshipsApi } from './clientRelationshipsApi';
import { accountAccessApi } from './accountAccessApi';
import { teamMembersApi } from './teamMembersApi';

const store = configureStore({
  reducer: {
    auth: authReducer,
    appView: appViewReducer,
    filters: filterReducer,
    viewingTag: viewingTagReducer,
    [authApi.reducerPath]: authApi.reducer,
    [appViewApi.reducerPath]: appViewApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [teamMemberApi.reducerPath]: teamMemberApi.reducer,
    [advisorInvestorsApi.reducerPath]: advisorInvestorsApi.reducer,
    [masterSearchApi.reducerPath]: masterSearchApi.reducer,
    [clientActivityApi.reducerPath]: clientActivityApi.reducer,

    [accountSetupApi.reducerPath]: accountSetupApi.reducer,
    [advisorGroupsApi.reducerPath]: advisorGroupsApi.reducer,
    [errorsApi.reducerPath]: errorsApi.reducer,
    [exportApi.reducerPath]: exportApi.reducer,
    [adminInvestorsApi.reducerPath]: adminInvestorsApi.reducer,
    [aggregatedAccountsApi.reducerPath]: aggregatedAccountsApi.reducer,
    [advisorAggregatedHoldingsApi.reducerPath]:
      advisorAggregatedHoldingsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [dashboardMessagesApi.reducerPath]: dashboardMessagesApi.reducer,
    [disclaimersApi.reducerPath]: disclaimersApi.reducer,
    [firmApi.reducerPath]: firmApi.reducer,
    [socialSettingsApi.reducerPath]: socialSettingsApi.reducer,
    [transactionsApi.reducerPath]: transactionsApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
    [contactsApi.reducerPath]: contactsApi.reducer,
    [diversificationsApi.reducerPath]: diversificationsApi.reducer,
    [quickLinksResourcesApi.reducerPath]: quickLinksResourcesApi.reducer,
    [colorsApi.reducerPath]: colorsApi.reducer,
    [gridColumnsApi.reducerPath]: gridColumnsApi.reducer,
    [holdingsApi.reducerPath]: holdingsApi.reducer,
    [cashFlowApi.reducerPath]: cashFlowApi.reducer,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [aggregatorCredentialsApi.reducerPath]: aggregatorCredentialsApi.reducer,
    [wealthsApi.reducerPath]: wealthsApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [pageVisibilityApi.reducerPath]: pageVisibilityApi.reducer,
    [tabsApi.reducerPath]: tabsApi.reducer,
    [yodleeApi.reducerPath]: yodleeApi.reducer,
    [permissionsApi.reducerPath]: permissionsApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [financialInstitutionsApi.reducerPath]: financialInstitutionsApi.reducer,
    [classificationsApi.reducerPath]: classificationsApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [insightsApi.reducerPath]: insightsApi.reducer,
    [mgpApi.reducerPath]: mgpApi.reducer,
    [integrationsApi.reducerPath]: integrationsApi.reducer,
    [performanceReportsApi.reducerPath]: performanceReportsApi.reducer,
    [termsApi.reducerPath]: termsApi.reducer,
    [eConsentApi.reducerPath]: eConsentApi.reducer,
    [advisorGroupModuleLocalizationsApi.reducerPath]:
      advisorGroupModuleLocalizationsApi.reducer,
    [propertyApi.reducerPath]: propertyApi.reducer,
    [eConsentConfigApi.reducerPath]: eConsentConfigApi.reducer,
    [dataFeedsApi.reducerPath]: dataFeedsApi.reducer,
    [setupAccountsApi.reducerPath]: setupAccountsApi.reducer,
    [homeAwayInstitutionsApi.reducerPath]: homeAwayInstitutionsApi.reducer,
    [feedClassificationsApi.reducerPath]: feedClassificationsApi.reducer,
    [clientInvitationConfigApi.reducerPath]: clientInvitationConfigApi.reducer,
    [clientRelationshipsApi.reducerPath]: clientRelationshipsApi.reducer,
    [accountAccessApi.reducerPath]: accountAccessApi.reducer,
    [teamMembersApi.reducerPath]: teamMembersApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(appViewApi.middleware)
      .concat(usersApi.middleware)
      .concat(teamMemberApi.middleware)
      .concat(accountSetupApi.middleware)
      .concat(advisorInvestorsApi.middleware)
      .concat(masterSearchApi.middleware)
      .concat(clientActivityApi.middleware)
      .concat(advisorGroupsApi.middleware)
      .concat(errorsApi.middleware)
      .concat(exportApi.middleware)
      .concat(adminInvestorsApi.middleware)
      .concat(aggregatedAccountsApi.middleware)
      .concat(advisorAggregatedHoldingsApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(dashboardMessagesApi.middleware)
      .concat(disclaimersApi.middleware)
      .concat(firmApi.middleware)
      .concat(socialSettingsApi.middleware)
      .concat(transactionsApi.middleware)
      .concat(accountsApi.middleware)
      .concat(contactsApi.middleware)
      .concat(diversificationsApi.middleware)
      .concat(quickLinksResourcesApi.middleware)
      .concat(colorsApi.middleware)
      .concat(gridColumnsApi.middleware)
      .concat(holdingsApi.middleware)
      .concat(cashFlowApi.middleware)
      .concat(documentsApi.middleware)
      .concat(aggregatorCredentialsApi.middleware)
      .concat(wealthsApi.middleware)
      .concat(notificationsApi.middleware)
      .concat(settingsApi.middleware)
      .concat(pageVisibilityApi.middleware)
      .concat(tabsApi.middleware)
      .concat(yodleeApi.middleware)
      .concat(permissionsApi.middleware)
      .concat(reportsApi.middleware)
      .concat(financialInstitutionsApi.middleware)
      .concat(classificationsApi.middleware)
      .concat(insightsApi.middleware)
      .concat(mgpApi.middleware)
      .concat(integrationsApi.middleware)
      .concat(eConsentApi.middleware)
      .concat(clientsApi.middleware)
      .concat(performanceReportsApi.middleware)
      .concat(termsApi.middleware)
      .concat(advisorGroupModuleLocalizationsApi.middleware)
      .concat(propertyApi.middleware)
      .concat(eConsentConfigApi.middleware)
      .concat(dataFeedsApi.middleware)
      .concat(setupAccountsApi.middleware)
      .concat(homeAwayInstitutionsApi.middleware)
      .concat(feedClassificationsApi.middleware)
      .concat(clientInvitationConfigApi.middleware)
      .concat(clientRelationshipsApi.middleware)
      .concat(accountAccessApi.middleware)
      .concat(teamMembersApi.middleware)
      .prepend(cacheInvalidationMiddleware.middleware),
});

export default store;
export type AppDispatch = typeof store.dispatch;

const _rootReducer = combineReducers({
  auth: authReducer,
  appView: appViewReducer,
  filters: filterReducer,
  viewingTag: viewingTagReducer,
  [authApi.reducerPath]: authApi.reducer,
  [appViewApi.reducerPath]: appViewApi.reducer,
});
export type WARootState = ReturnType<typeof _rootReducer>;
